module.exports = __webpack_public_path__ + "img/part-1-title.81633630.png";